export enum CropResiduesUtilizationType {
  Ploughing = 'Ploughing',
  Mulching = 'Mulching',
  NoPloughing = 'NoPloughing'
}
